import script from "./mediaSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./mediaSection.vue?vue&type=script&setup=true&lang=ts"

import "./mediaSection.vue?vue&type=style&index=0&id=5d663794&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d663794"]])

export default __exports__